import { ImageCell } from '@/components/shared/ImageCell';
import type { AttractionCategory } from '@/config/objects/attraction-categories';

interface AttractionCategoryImageCellProps {
  attractionCategory?: AttractionCategory;
  size?: 'sm' | 'lg';
}

/**
 * Editable attraction category image cell component with upload and delete actions
 */
export function AttractionCategoryImageCell({
  attractionCategory,
  size = 'sm',
}: AttractionCategoryImageCellProps) {
  return (
    <ImageCell
      item={attractionCategory}
      endpoint="/attraction-categories"
      entityName="Attraction Category"
      imageLabel="Attraction Category Image"
      getFeaturedImage={(item) => item.featuredImage}
      getItemId={(item) => item.id}
      size={size}
    />
  );
}
